import React, { useState, useEffect }  from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import GitHubIcon from '@material-ui/icons/GitHub';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { IconButton } from '@material-ui/core';
const styles = {
  card: {
    bgcolor : 'red',
    //minWidth : 200,
    minheight : 220,
    //minHeight : 200,
  },
  header : {
      maxWidth : 20,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    marginBottom: 16,
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
};

function SimpleCard(props) {
  const { classes } = props;
  const bull = <span className={classes.bullet}>•</span>;

  const [userData, setUserData] = useState({});
    const [loading,setLoading] = useState(true);
    //const classes = useStyles();
    useEffect(() => {
        getGitHubUserWithFetch();
    }, []);

    const getGitHubUserWithFetch = async () => {
        const response = await fetch(props.languages_url);
        const jsonData = await response.json();
        setUserData(jsonData);
        setLoading(false);
    };

  const defaultProps = {
    //bgcolor: 'red',
    borderColor: 'text.primary',
    //m: 1,
    p : 1,
    border: 1,
    style: { width: '20rem', height: '15rem' },
  };

  const goto = ()=>{
    window.open(props.html_url); 
  }

  const getActionsWithStars = ()=>{
    return <Grid container justify="space-between" alignContent="center" >
    <Grid item >
        <Grid container direction="row" alignItems="center">
          <Grid item>
            <StarBorderIcon fontSize="large" style={{color : "#379683"}}/>
          </Grid>
          <Grid item>
            <Typography variant="display1" style={{color : "#379683"}}>
            {props.stars}
            </Typography>
          </Grid>
        </Grid>
    </Grid>
    <Grid item>
    <Button onClick={goto} size="small" style={{color : "#379683"}}>Know More<ArrowForwardIcon style={{color : "#379683"}}/></Button>
    </Grid>
  </Grid>
  }

  const getActionsWithoutStars = ()=>{
    return <Grid container justify="flex-end" alignContent="center" >
    <Grid item>
    <Button onClick={goto} size="small" style={{color : "#379683"}}>Know More<ArrowForwardIcon style={{color : "#379683"}} /></Button>
    </Grid>
  </Grid>
  }
  const getLang = () => {
    // console.log("Languages: ", userData)
    var languages = ""
    for(var lang in userData) {
      languages += lang
      languages += ","
    }
    if(languages === ''){
      return 'No languages detected.'
    }
    return languages.substring(0,languages.length-1)
  }
  return (
    <div>
      <Card className={classes.card} raised={true}  >
        <CardContent>
          <Typography variant="h6" component="h2">
            <Grid container justify="space-between">
              <Grid item style={{color : "#ff726f"}}>
                {props.repoName}
              </Grid>
              <Grid item>
              <IconButton style ={{color : "#c92828"}} aria-label="repo-link" onClick={goto}>
                <GitHubIcon />
              </IconButton>
              </Grid>
            </Grid>
          </Typography>
          <Typography className={classes.title} color="textSecondary">
            {props.description!==null?`${props.description},`: 'No description added..'}
          </Typography>
          <Typography className={classes.pos} color="textSecondary">
            Languages : {loading ?   "Loading.. " :  getLang()}
            
          </Typography>
        </CardContent>
        <CardActions>
          {props.stars > 0 ? getActionsWithStars(): getActionsWithoutStars() }
        </CardActions>
      </Card>
    </div>
  );
}

SimpleCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SimpleCard);
